/*
 * Copyright (C) 2025. - SimpliCity Digital Inc - All Rights Reserved
 */

import { configureStore } from "@reduxjs/toolkit";
import { useDispatch as useAppDispatch } from "react-redux";
import { useSelector as useAppSelector } from "react-redux";
import reducers from "./reducers";

const store = configureStore({
    reducer: reducers,
    middleware (getDefaultMiddleware) {
        return getDefaultMiddleware();
    }
});

const { dispatch } = store;

const useDispatch = () => useAppDispatch();
const useSelector = useAppSelector;

export { dispatch, store, useDispatch, useSelector };

